import { render, staticRenderFns } from "./companyBrief.vue?vue&type=template&id=0d8b561c&scoped=true"
import script from "./companyBrief.vue?vue&type=script&lang=js"
export * from "./companyBrief.vue?vue&type=script&lang=js"
import style0 from "./companyBrief.vue?vue&type=style&index=0&id=0d8b561c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b561c",
  null
  
)

export default component.exports